import './utils/productionConsole';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';

import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

// Configure redux store
const preloadedState = {};
const store = configureStore(preloadedState);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider >,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
